import { FC } from "react";
import { Title } from "@mantine/core";

import { Issue } from "@protos/issues/v1/issues";
import { HoverCopyButton } from "@shared/components";

import { formatRuleName } from "../../../utils";

export interface RuleTitleProps {
  finding: Issue;
}

/**
 *
 * @param finding - a formatted finding
 * @returns the rule name
 */
export const RuleTitle: FC<RuleTitleProps> = ({ finding }) => {
  return (
    <HoverCopyButton
      copyText={finding.rulePath}
      tooltipText="Copy full rule name"
    >
      <Title lineClamp={1} fz="lg" order={5}>
        {formatRuleName(finding.rulePath ?? "")}
      </Title>
    </HoverCopyButton>
  );
};
